import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthenticationService } from '@services/authentication/authentication.service';
import LogRocket from 'logrocket';
import { first } from 'rxjs/operators';
import { PillInputComponent } from 'src/app/shared/atomic/atoms/pill-input/pill-input.component';
import { multipleEmailsValidator } from 'src/app/shared/validators/multiple-emails.validator';

export enum UserInvitesSendState {
	INPUT = 0,
	SENDING = 1,
	SENT = 2,
	ERROR = 3,
}
@UntilDestroy()
@Component({
	selector: 'app-create-user-invite',
	templateUrl: './create-user-invite.component.html',
	styleUrls: ['./create-user-invite.component.scss'],
	standalone: false,
})
export class CreateUserInviteComponent implements OnInit {
	@ViewChild(PillInputComponent) pillInput: PillInputComponent;
	@Input() businessName: string;
	@Input() createdByName: string;
	@Input() createdByEmail: string;

	@Output() onSendInvites: EventEmitter<string[]> = new EventEmitter();
	@Output() onSubmit: EventEmitter<void> = new EventEmitter();
	@Output() onBack: EventEmitter<void> = new EventEmitter();

	public inviteControl: FormControl;
	public emailValidator = multipleEmailsValidator();
	public SendStates = UserInvitesSendState;
	public sendState = UserInvitesSendState.INPUT;
	public icons = ICON;

	constructor(private authenticationService: AuthenticationService) {}

	ngOnInit(): void {
		this.inviteControl = new FormControl([]);
		this.inviteControl.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
			if (this.sendState === UserInvitesSendState.SENT) {
				this.sendState = UserInvitesSendState.INPUT;
			}
		});
	}

	public async sendInvites(): Promise<void> {
		if (this.inviteControl.value.length) {
			this.sendState = UserInvitesSendState.SENDING;
			const emails = this.inviteControl.value as string[];
			await this.createInvite(emails);
		}
		this.onSubmit.emit();
	}

	public _onBack = (): void => {
		this.onBack.emit();
	};

	public onTextInput(): void {
		if (this.sendState === this.SendStates.SENT) {
			this.sendState = this.SendStates.INPUT;
		}
	}

	public async createInvite(inviteEmails: string[]): Promise<void> {
		this.authenticationService
			.createInvites(inviteEmails, this.createdByName, this.businessName)
			.pipe(first())
			.subscribe(
				() => {
					this.sendState = UserInvitesSendState.SENT;
					this.inviteControl.reset([]);
					this.pillInput.inputControl.reset('');
				},
				(err) => {
					LogRocket.captureException(err);
				},
			);
	}
}
